import clsx from 'clsx';
import React, { ReactElement, useContext } from 'react';
import {
  composeRenderProps,
  Button as RACButton,
  ButtonProps as RACButtonProps,
} from 'react-aria-components';
import { DateRangePickerStateContext } from 'react-aria-components';
import { tv } from 'tailwind-variants';
import { focusRing } from './date-range-picker-date-field';

export interface ButtonProps extends RACButtonProps {
  variant?: 'icon';
  className?: string;
}

const button = tv({
  extend: focusRing,
  base: 'text-center outline-none transition border border-black/10  shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] cursor-pointer selected:bg-transparent',
  variants: {
    variant: {
      icon: 'border-0 p-1 flex items-center justify-center ',
    },
    isDisabled: {
      true: 'cursor-not-allowed text-gray-200',
    },
  },
});

export const Button = (props: ButtonProps): ReactElement => {
  const stateCalendar = useContext(DateRangePickerStateContext);
  return (
    <RACButton
      {...props}
      className={composeRenderProps(
        clsx(props.className, {
          'text-primary-600': stateCalendar?.isOpen,
        }),
        (className, renderProps) => {
          return button({ ...renderProps, variant: props.variant, className });
        },
      )}
    />
  );
};
